import { FundingBatchDetailStatus } from './funding-batch-detail-status';
import { InvoiceSummary } from './invoice-summary';
import { RedactedBankAccount } from './redacted-bank-account';
import { TransactionFeeType } from './transaction-fee-type';
import { Money } from '@lsq-frontend/remote-services/all-java/common-mk0';

export class FundingBatchDetail {
    public createdAt: object;
    public fundingDate: object;
    public totalFundingAmount: Money;
    public totalDiscountAmount: Money;
    public paidOutAmount: Money;
    public invoiceSummaries: InvoiceSummary[];
    public bankAccountDetails: RedactedBankAccount;
    public refSellerKey: string;
    public status: FundingBatchDetailStatus;
    public invoiceCount: number;
    public totalApprovedAmount: Money;
    public refFundingBatchKey: string;
    public transactionFeeAmount: Money;
    public transactionFeeType: TransactionFeeType;
    public totalEarlyPaidAmountFee: Money;
    public buyerDiscountAmount: Money;
    public supplierDiscountAmount: Money;
    public buyerPaidTransactionFee: boolean;
    constructor(obj?: {
       createdAt?: object;
       fundingDate?: object;
       totalFundingAmount?: Money;
       totalDiscountAmount?: Money;
       paidOutAmount?: Money;
       invoiceSummaries?: InvoiceSummary[];
       bankAccountDetails?: RedactedBankAccount;
       refSellerKey?: string;
       status?: FundingBatchDetailStatus;
       invoiceCount?: number;
       totalApprovedAmount?: Money;
       refFundingBatchKey?: string;
       transactionFeeAmount?: Money;
       transactionFeeType?: TransactionFeeType;
       totalEarlyPaidAmountFee?: Money;
       buyerDiscountAmount?: Money;
       supplierDiscountAmount?: Money;
       buyerPaidTransactionFee?: boolean;
    }) {
        if (obj != null) {
            this.createdAt = typeof obj.createdAt === 'undefined' ? this.createdAt : obj.createdAt;
            this.fundingDate = typeof obj.fundingDate === 'undefined' ? this.fundingDate : obj.fundingDate;
            this.totalFundingAmount = typeof obj.totalFundingAmount === 'undefined' ? this.totalFundingAmount : obj.totalFundingAmount;
            this.totalDiscountAmount = typeof obj.totalDiscountAmount === 'undefined' ? this.totalDiscountAmount : obj.totalDiscountAmount;
            this.paidOutAmount = typeof obj.paidOutAmount === 'undefined' ? this.paidOutAmount : obj.paidOutAmount;
            this.invoiceSummaries = typeof obj.invoiceSummaries === 'undefined' ? this.invoiceSummaries : obj.invoiceSummaries;
            this.bankAccountDetails = typeof obj.bankAccountDetails === 'undefined' ? this.bankAccountDetails : obj.bankAccountDetails;
            this.refSellerKey = typeof obj.refSellerKey === 'undefined' ? this.refSellerKey : obj.refSellerKey;
            this.status = typeof obj.status === 'undefined' ? this.status : obj.status;
            this.invoiceCount = typeof obj.invoiceCount === 'undefined' ? this.invoiceCount : obj.invoiceCount;
            this.totalApprovedAmount = typeof obj.totalApprovedAmount === 'undefined' ? this.totalApprovedAmount : obj.totalApprovedAmount;
            this.refFundingBatchKey = typeof obj.refFundingBatchKey === 'undefined' ? this.refFundingBatchKey : obj.refFundingBatchKey;
            this.transactionFeeAmount = typeof obj.transactionFeeAmount === 'undefined' ? this.transactionFeeAmount : obj.transactionFeeAmount;
            this.transactionFeeType = typeof obj.transactionFeeType === 'undefined' ? this.transactionFeeType : obj.transactionFeeType;
            this.totalEarlyPaidAmountFee = typeof obj.totalEarlyPaidAmountFee === 'undefined' ? this.totalEarlyPaidAmountFee : obj.totalEarlyPaidAmountFee;
            this.buyerDiscountAmount = typeof obj.buyerDiscountAmount === 'undefined' ? this.buyerDiscountAmount : obj.buyerDiscountAmount;
            this.supplierDiscountAmount = typeof obj.supplierDiscountAmount === 'undefined' ? this.supplierDiscountAmount : obj.supplierDiscountAmount;
            this.buyerPaidTransactionFee = typeof obj.buyerPaidTransactionFee === 'undefined' ? this.buyerPaidTransactionFee : obj.buyerPaidTransactionFee;
        }
    }
}
